import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Image} from '../../atoms/Image/Image';
import {EmoticonPreviewProps} from './EmoticonPreviewProps.interface';

export function EmoticonPreview({
  imageUrl,
  onClickClose,
}: EmoticonPreviewProps) {
  return (
    <div className="relative h-96pxr w-full bg-static-etc-dimmed">
      <Image
        src={imageUrl}
        className="absolute top-16pxr right-32pxr h-70pxr w-70pxr"
        alt="이모티콘 미리보기"
        ratio={1}
      />
      <Icon
        className="absolute top-10pxr right-16pxr cursor-pointer"
        type={IconType.ListClose}
        onClick={onClickClose}
      />
    </div>
  );
}
